/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:28
 * @LastEditTime: 2019-07-24 14:01:32
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  普通仓库需求管理接口Url
const websiteIndexDemandUrl = '/website/index/storage/storageDemand'

//  普通仓库需求管理接口Url
const websiteDemandUrl = '/website/storage/demand'

// 分页查询普通仓库需求列表
export function findPageDemand(param, userType) {
  const demandUrl = userType == '' ? websiteIndexDemandUrl : websiteDemandUrl
  return logistice({
    url: LOGISTICE_GATEWAY + demandUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageDemand'
      }, param))
    }
  })
}
